import Vue from 'vue'
import App from './App.vue'
import './quasar'
import router from './router/index'
import VueTheMask from 'vue-the-mask'
import dateFormatMixin from "./mixins/dateFormatMixin";
import AmazoniaFramework from 'amazonia-framework-frontend'

Vue.use(AmazoniaFramework, {router, App})
Vue.use(VueTheMask)
Vue.mixin( dateFormatMixin )
